import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./components/login/Login";
import Home from "./components/Home";
import ListManagement from "./components/ListManagement/ListManagement";
import UserManagement from "./components/UserManagement/UserManagement";
import AdminManagement from "./components/AdminManagement/AdminManagement";
import NotFound from "./components/NotFound";
import CreatePassword from "./components/login/CreatePassword";
import { AllUsers } from "./components/protectedRoutes/AllUsers";
import { AdminOnly } from "./components/protectedRoutes/AdminOnly";
import { MediaOnly } from "./components/protectedRoutes/MediaOnly";
import { ManagerOnly } from "./components/protectedRoutes/MangerOnly";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/home"
            element={
              <AllUsers>
                <Home />
              </AllUsers>
            }
          />
          <Route
            path="/list-management"
            element={
              <AllUsers>
                <ListManagement />
              </AllUsers>
            }
          />
          <Route
            path="/user-management"
            element={
              <AdminOnly>
                <UserManagement />
              </AdminOnly>
            }
          />
          <Route
            path="/admin-management"
            element={
              <AdminOnly>
                <AdminManagement />
              </AdminOnly>
            }
          />
          <Route path="/create-password" element={<CreatePassword />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
